import React, { useState } from 'react';
import { ArrowUpIcon, ArrowDownIcon, Box, Inscription } from '@common-fe/common-fe';

import { PLAN_REACTIVATION_STEPS } from '../constants';

import { ResumeListItem } from './ResumeListItem';

interface Props {
  testId?: string;
}

export const ResumeNextSteps: React.FC<Props> = ({ testId = 'ResumeNextSteps' }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Box
      data-testid={testId}
      pad={{ vertical: 'spacing12', horizontal: 'spacing16' }}
      margin={{ bottom: 'spacing24' }}
      background={{ color: 'border1' }}
      round="container2Round"
    >
      <Box
        direction="row"
        align="center"
        gap="spacing2"
        margin={{ bottom: isExpanded ? 'spacing8' : '0' }}
        onClick={() => setIsExpanded(prev => !prev)}
        style={{ cursor: 'pointer', userSelect: 'none' }}
      >
        {isExpanded ? <ArrowUpIcon /> : <ArrowDownIcon />}
        <Inscription data-testid={`${testId}_title`}>The next steps</Inscription>
      </Box>

      <ol
        data-testid={`${testId}_list`}
        style={{
          margin: 0,
          paddingLeft: '4px',
          listStyle: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: isExpanded ? '24px' : '0px',
          maxHeight: isExpanded ? '1000px' : '0px',
          opacity: isExpanded ? 1 : 0,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, gap 0.3s ease-in-out',
        }}
      >
        {PLAN_REACTIVATION_STEPS.map((step, index) => (
          <ResumeListItem
            key={index}
            index={index + 1}
            title={step.title}
            description={step.description}
            testId={`${testId}_item_${index}`}
          />
        ))}
      </ol>
    </Box>
  );
};
